import { Helpers } from '../../helpers';
import { IProvenDevelopedProducingDataset } from '../../interfaces/iproven-developed-producing-dataset';
import { ForecastHorizontal } from '../forecast-horizontal';

export class ProvenDevelopedProducingDatasetBase {
  ProvenDevelopedProducingDatasetId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal_ProvenDevelopedProducingDataset?: Array<ForecastHorizontal> | null;

  constructor(item?: IProvenDevelopedProducingDataset) {
    if (item) {

      this.ProvenDevelopedProducingDatasetId = item.ProvenDevelopedProducingDatasetId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal_ProvenDevelopedProducingDataset = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_ProvenDevelopedProducingDataset);
    }
  }
}